import { useQuery } from "react-query";
import axios from "axios";
import { getApiPath } from "../../utils/variables";
import { objectToUrlEncoded } from "../../utils/constants";

export function getConference(id, nocache) {
  if (!id) {
    return Promise.reject(new Error("id is required"));
  }
  const url = `${getApiPath(false)}/conference/${id}?${Date.now()}${
    nocache ? "&nocache=true" : ""
  }`;
  return axios.get(url, {});
}

export function useGetConference(id, nocache) {
  return useQuery([`conference-${id}`], () => getConference(id, nocache), {
    refetchOnMount: false,
    cacheTime: 300000,
  });
}

export function useGetReferredHandlesCount(data) {
  return useQuery(
    ["referredHandlesCount", data.id],
    () => {
      const id = data.id;
      const params = data;
      delete params.id;
      const url = `${getApiPath(false)}/conference/${id}/referredHandlesCount`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!data?.id,
    }
  );
}

export function useGetConferenceDols(data) {
  return useQuery(
    ["conferenceDols", data.id],
    () => {
      const id = data.id;
      const params = data;
      delete params.id;
      const url = `${getApiPath(false)}/conference/${id}/dols`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!data?.id,
    }
  );
}

export function useGetConferenceDolsByViews(data) {
  return useQuery(
    ["conferenceDolsByViews", data.id],
    () => {
      const id = data.id;
      const params = data;
      delete params.id;
      const url = `${getApiPath(false)}/conference/${id}/dolsByViews`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!data?.id,
    }
  );
}

export function useGetConferenceByCountry(data) {
  return useQuery(
    ["conferenceByCountry", data.id],
    () => {
      const id = data.id;
      const params = data;
      delete params.id;
      const url = `${getApiPath(
        false
      )}/conference/${id}/countrySegmentedSummary`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!data?.id,
    }
  );
}

export function useInfluencerStats(id) {
  return useQuery(
    ["influencerStats", id],
    () => {
      const url = `${getApiPath(false)}/conference/${id}/overallStats`;
      return axios.get(url, {});
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!id,
    }
  );
}

// /notauth/tweets/timeSegmentedSummary?tagId=DB13D21C76B211EF8382C65FD8ACA69B&tagId=FC793562A31711ECBA9012555EBF9BF2&originalOnly=false&includeReplies=false&startDate=2025-01-22T00:00:00&endDate=2025-01-27T23:59:59&segment=HOUR
export function useTimeSegmentedTweets(params) {
  return useQuery(
    ["timeSegmentedTweets", params],
    () => {
      let encodedParams = objectToUrlEncoded(params);
      encodedParams = encodedParams.replace("parentTagId", "tagId");
      const url = `${getApiPath(
        false
      )}/tweets/timeSegmentedSummary?${encodedParams}`;
      return axios.get(url, {});
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!params?.tagId,
    }
  );
}
